import * as React from "react"
import NetlifyForm from "./NetlifyForm"

export default () => (
  <NetlifyForm
    title={"Contact Us"}
    action={"/thanks"}
    name={"contact"}
    render={handleChange => (
      <React.Fragment>
        <div>
          <label>
            <div className={"label required"}>First Name</div>
            <input
              type="text"
              name="first-name"
              onChange={handleChange}
              placeholder={"First Name"}
              required
            />
          </label>
        </div>
        <div>
          <label>
            <div className={"label required"}>Last Name</div>
            <input
              type="text"
              name="last-name"
              onChange={handleChange}
              placeholder={"Last Name"}
              required
            />
          </label>
        </div>
        <div>
          <label>
            <div className={"label required"}>Email</div>
            <input
              type="email"
              name="email"
              onChange={handleChange}
              placeholder={"Email"}
              required
            />
          </label>
        </div>
        <div>
          <label>
            <div className={"label required"}>Phone Number</div>
            <input
              type="tel"
              name="phone"
              onChange={handleChange}
              placeholder={"Phone Number"}
              required
            />
          </label>
        </div>
        <div>
          <label>
            <div className={"label required"}>How can we help today?</div>
            <textarea
              rows={10}
              name="message"
              onChange={handleChange}
              placeholder={"How can we help today?"}
              required
            />
          </label>
        </div>
        <div>
          <label
            style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}
          >
            <input
              type="checkbox"
              name="newsletter-consent"
              onChange={handleChange}
              style={{ width: "auto", marginTop: "3px" }}
            />
            <span>
              I agree to receive communication on newsletters, promotional
              content, offers and events.
            </span>
          </label>
        </div>
      </React.Fragment>
    )}
  />
)
